import { useQuery } from '@tanstack/react-query'
import { axiosInstance } from '@/modules/shared/lib/axios'
import { VehicleModel } from '@/app/models/vehicleModel'
import { MINUTE_IN_MS } from '@/modules/shared/constants/time'

type Props = {
  companyId: string
}

/**
 * Fetches vehicles for a company
 */
export function useQueryVehicles({ companyId }: Props) {
  return useQuery<VehicleModel[]>({
    queryKey: ['vehicles', companyId],
    queryFn: async () => {
      const { data } = await axiosInstance.get(`api/${companyId}/vehicle/list`)
      return data || []
    },
    staleTime: MINUTE_IN_MS * 5, // cache for 5 minutes
    enabled: !!companyId,
  })
}

